import React from 'react';
import Alert from '@material-ui/lab/Alert';

export const InvalidPayoutSettings = (): JSX.Element => (
    <Alert severity={'error'}>
        You have not filled out your payout settings, please do so before claiming a payout.
    </Alert>
);
